import React from "react";
import { Box } from "arkh";
import { FormattedMessage } from "react-intl";
import { OrgSpaceCreateTitles } from "./OrgSpaceCreateTitles";
import { Lottie } from "../../../components/Lottie";
import { View } from "react-native";

export function OrgSpaceCreatePageSuccess(props: { name: string }) {
  return (
    <Box spaceHorizontal="xxlarge">
      <OrgSpaceCreateTitles
        title={
          <FormattedMessage
            defaultMessage="Success! {name} is created!"
            description="OrgSpaceCreatePageFilter title"
            values={{
              name: props.name,
            }}
          />
        }
        subTitle={
          <FormattedMessage
            defaultMessage="You are now able to fill the Storecast Space with widgets. Explore various layouts and keep the content updated."
            description="OrgSpaceCreatePageFilter description"
          />
        }
      />
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <Lottie autoPlay loop source={require("./OrgSpaceDoneLottie.json")} />
      </View>
    </Box>
  );
}
